import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

interface IsEligibleForOnboardingProps {
  isSourceBilly: boolean
  isUmbrellaMember: boolean
  organization?: Organization
}

const onboardingExcludedPlans = [
  SubscriptionPlan.CegidEnterpriseFree,
  SubscriptionPlan.EBPFree,
  SubscriptionPlan.IToolFree,
  SubscriptionPlan.QuadraFree,
]

/**
 * Eligibility requirements (all must be true):
 * - Organization is not a CPA client (ownerUmbrellaId is null)
 * - User is not an umbrella member
 * - Organization is not on a partner-specific plan (quadra_free, ebp_free, itool_free, cegid_enterprise_free)
 * - Organization source is not billy (onboarding is for Shine only)
 * - Organization was not migrated from Zervant
 */
export const isEligibleForOnboarding = ({
  isSourceBilly,
  isUmbrellaMember,
  organization,
}: IsEligibleForOnboardingProps): boolean => {
  if (!organization) {
    return false
  }

  const isCpaClient = !!organization.ownerUmbrellaId
  const isEligiblePlan = !onboardingExcludedPlans.includes(organization.subscriptionProductPlan)
  const isMigratedFromZervant = organization.migrationOrigin === 'zervant'

  return !isCpaClient && !isUmbrellaMember && isEligiblePlan && !isSourceBilly && !isMigratedFromZervant
}
